import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/api";
import { SiteFooter } from "@/components/shared/SiteFooter";

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    let cancelled = false;
    if (!token) {
      setStatus("error");
      setMessage("Lien invalide.");
      return;
    }
    api.get(`/auth/unsubscribe?token=${encodeURIComponent(token)}`)
      .then((res) => {
        if (cancelled) return;
        setStatus("success");
        setMessage(
          res?.data?.message
          || "Vous avez été désinscrit, vous ne recevrez plus d'emails de Blanc des Montagnes."
        );
      })
      .catch((e) => {
        if (cancelled) return;
        setStatus("error");
        setMessage(
          e?.response?.data?.detail
          || "Le lien est invalide ou a expiré."
        );
      });
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="min-h-screen flex flex-col bg-[#0b1020] text-slate-100">
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div data-testid="unsubscribe-card" className="max-w-md w-full rounded-2xl border border-white/10 bg-white/[0.04] p-8 text-center shadow-xl">
          <div className="text-4xl mb-4">
            {status === "loading" ? "⌛" : status === "success" ? "✓" : "✕"}
          </div>
          <h1 data-testid="unsubscribe-title" className="text-2xl font-semibold mb-3">
            {status === "loading" ? "Traitement…" : status === "success" ? "Désinscription confirmée" : "Erreur"}
          </h1>
          <p data-testid="unsubscribe-message" className="text-sm text-slate-300 leading-relaxed">
            {message}
          </p>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
